// extracted by mini-css-extract-plugin
export default {"Training":"training_Training__65c84","Spinner":"training_Spinner__riK0B","image-container":"training_image-container__vMrwp"};